//#region imports
import { Component, OnInit } from '@angular/core';
import { AppConstants } from '../../../../app.constants';
import { TranslateService } from '@ngx-translate/core';
import { NotificationService } from 'src/app/services/notification.service';
import { DetailsService } from 'src/app/services/details.service';
import { Globals } from 'src/app/services/globals';
import { formatDate } from '@angular/common';
import { GuaranteeService } from 'src/app/services/guarantee.service';
import { SectionService } from 'src/app/services/section.service';
import {PixelService} from 'ngx-pixel';
//#endregion

@Component({
  selector: 'app-details-question1',
  templateUrl: './details-question1.component.html',
  styleUrls: ['./details-question1.component.css']
})
export class DetailsQuestion1Component implements OnInit {
  //#region variables
  detailsValue = 0;
  error = false;
  error1 = false;
  error2 = false;
  error3 = false;
  choices = [];
  ch11 = '123';
  firstQuestion = 1;
  secondQuestion = 0;
  thirdQuestion = 0;
  questions = [];
  //#endregion

  //#region methods
  constructor(
    private detailsService: DetailsService, private notification: NotificationService,
    private translate: TranslateService, private globals: Globals,
    private guaranteeService: GuaranteeService, private sectionService: SectionService, private pixel: PixelService) { }
    
  ngOnInit() {
    this.sectionService.setCurrentPage('P21-1');
    
    this.pixel.track('AddToCart');
    this.globals.trackPageActivity += ';' + 'P21-1';
    const sectionKey = AppConstants.SectionConstants.Section2Point1;
    this.questions = this.detailsService.getDetailsQuestion(sectionKey, 'G6');
    this.setAnswers();
    this.globals.quesWarning = false;
  }

  setAnswers() {
    const jsonData = sessionStorage.getItem('jsonData');
    const data = JSON.parse(jsonData);
    const firstAnswer = data.Sections.find(obj => obj.SectionKey === 'S2.1').
    QuestionGroup.find(obj => obj.GroupKey === 'G6').
    Questions.find(obj => obj.QuestionKey === 'House_Rooms_Question').Answers;
    this.firstQuestion = firstAnswer != null ? firstAnswer[0].AnswerText : this.firstQuestion;
    const secondAnswer = data.Sections.find(obj => obj.SectionKey === 'S2.1').
    QuestionGroup.find(obj => obj.GroupKey === 'G6').
    Questions.find(obj => obj.QuestionKey === 'House_Shelters_Question').Answers;
    this.secondQuestion = secondAnswer != null ? secondAnswer[0].AnswerText : this.secondQuestion;
    const thirdAnswer = data.Sections.find(obj => obj.SectionKey === 'S2.1').
    QuestionGroup.find(obj => obj.GroupKey === 'G6').
    Questions.find(obj => obj.QuestionKey === 'House_Annex_Less_50_Question').Answers;
    this.thirdQuestion = thirdAnswer != null ? thirdAnswer[0].AnswerText : this.thirdQuestion;
    this.mapAnswer('House_Rooms_Question', this.firstQuestion);
    this.mapAnswer('House_Shelters_Question', this.secondQuestion);
    this.mapAnswer('House_Annex_Less_50_Question', this.thirdQuestion);
    // this.validateError();
  }

  isNumber(evt, code) {
    this.detailsService.setDetailsProgressBarDetails();
    if(this.globals.isMobile)
    {this.detailsService.setmobileDetailsProgressBarDetails();}
    // if (code === 0) {
    //   evt = (evt) ? evt : window.event;
    //   evt.preventDefault();
    // } else {
      evt = (evt) ? evt : window.event;
      const charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((code.length > 3) || (charCode > 31 && (charCode < 48 || charCode > 57))) {
        evt.preventDefault();
      } else {
        return true;
      }
    // }
  }

  incrementValue(choice, value, questionOrder) {
    value = +(value);
    this.guaranteeService.setInitialPricingData(null);
    this.detailsService.setDetailsProgressBarDetails();
    if(this.globals.isMobile)
    {this.detailsService.setmobileDetailsProgressBarDetails();}
    this.firstQuestion = (questionOrder === 1 && value >= 0 && value < 99) ? this.mapAnswer(choice, value + 1) : this.firstQuestion;
    this.secondQuestion = (questionOrder === 2 && value >= 0 && value < 99) ? this.mapAnswer(choice, value + 1) : this.secondQuestion;
    this.thirdQuestion = (questionOrder === 3 && value >= 0 && value < 99) ? this.mapAnswer(choice, value + 1) : this.thirdQuestion;
    this.error = this.firstQuestion > 0 ? false : true;
    this.validateError();
  }

  decrementValue(choice, value, questionOrder) {
    value = +(value);
    this.guaranteeService.setInitialPricingData(null);
    this.detailsService.setDetailsProgressBarDetails();
    if(this.globals.isMobile)
    {this.detailsService.setmobileDetailsProgressBarDetails();}
    this.firstQuestion = (questionOrder === 1 && value > 1) ? this.mapAnswer(choice, value - 1) : this.firstQuestion;
    this.secondQuestion = (questionOrder === 2 && value > 0) ? this.mapAnswer(choice, value - 1) : this.secondQuestion;
    this.thirdQuestion = (questionOrder === 3 && value > 0) ? this.mapAnswer(choice, value - 1) : this.thirdQuestion;
    this.validateError();
  }
    validateError(){
    if(!this.error)
    this.error = this.firstQuestion > 0 ? false : true; 
      this.detailsService.setDisableDetailsNext(this.error)
    if ((this.error1 || this.error2 || this.error3 || this.error))
    {
      this.detailsService.setDisableDetailsNext(true);
    } 
    else
    {
      this.detailsService.setDisableDetailsNext(false);
    } 
  }
  modelChanged(choice, enteredValue) {
    this.guaranteeService.setInitialPricingData(null);
    this.detailsService.setDetailsProgressBarDetails();
    if(this.globals.isMobile)
    {this.detailsService.setmobileDetailsProgressBarDetails();}

    if (enteredValue.length >= 1) {
      if (enteredValue > 99) {
        enteredValue = +(enteredValue.toString().slice(0, 2));
        this.firstQuestion = this.firstQuestion > 99 ? 1 : 1;
        this.secondQuestion = this.secondQuestion > 99 ? 0 : 0;
        this.thirdQuestion = this.thirdQuestion > 99 ? 0 : 0;
        this.validateNumbers(choice);
      } else if (enteredValue < 0) {
        enteredValue = '';
        this.firstQuestion = this.firstQuestion <= 0 ? 1 : 1;
        this.secondQuestion = this.secondQuestion < 0 ? 0 : 0;
        this.thirdQuestion = this.thirdQuestion < 0 ? 0 : 0;
        this.validateNumbers(choice);
      } else if ((enteredValue === 0) && (choice === 'House_Rooms_Question')) {
        this.firstQuestion = 0;
        this.error = true;
        this.validateNumbers(choice);
      } else {
        this.error = false;
        this.mapAnswer(choice, enteredValue);
      }
    } else {
      this.mapAnswer(choice, null);
    }
    this.validateError();

  }

  validateNumbers(selectedChoice) {
    switch (selectedChoice) {
      case 'House_Rooms_Question':
        this.mapAnswer(selectedChoice, this.firstQuestion);
        break;
      case 'House_Shelters_Question':
        this.mapAnswer(selectedChoice, this.secondQuestion);
        break;
      case 'House_Annex_Less_50_Question':
        this.mapAnswer(selectedChoice, this.thirdQuestion);
        break;
    }
  }

  mapAnswer(selectedChoice, selectedText) {
    const jsonData = sessionStorage.getItem('jsonData');
    const data = JSON.parse(jsonData);
    let AnswerObject = {};
    let selectedQuestion: any;
    const today = new Date();
    switch (selectedChoice) {
      case 'House_Rooms_Question':
        if (isNaN(selectedText)){
          this.error1 = true;
        }else if(selectedText === null || selectedText === '')
        {
          this.error1 = true;
        }
        else{
          this.error1 = false;
        }
        selectedQuestion = this.questions.find(obj => obj.QuestionKey === 'House_Rooms_Question');
        AnswerObject = !!selectedText ? {
          ChoiceId: selectedQuestion.QuestionId, Answerkey: selectedQuestion.QuestionKey, AnswerText: selectedText,
          AnsweredDateTime: formatDate(today, 'dd-MM-yyyy hh:mm:ss', 'en-US', '+0530')
        } : null;

        data.Sections.find(obj => obj.SectionKey === 'S2.1').
          QuestionGroup.find(obj => obj.GroupKey === 'G6').
          Questions.find(obj => obj.QuestionKey === 'House_Rooms_Question').Answers = AnswerObject != null ? [AnswerObject] : null;
        break;
      case 'House_Shelters_Question':
        if (isNaN(selectedText)){
          this.error2 = true;
        }else if(selectedText === null || selectedText === '')
        {
          this.error2 = true;
        }
        else{
          this.error2 = false;
        }
        selectedQuestion = this.questions.find(obj => obj.QuestionKey === 'House_Shelters_Question');
        AnswerObject = !!selectedText || +(selectedText) === 0 ? {
          ChoiceId: selectedQuestion.QuestionId, Answerkey: selectedQuestion.QuestionKey, AnswerText: selectedText,
          AnsweredDateTime: formatDate(today, 'dd-MM-yyyy hh:mm:ss', 'en-US', '+0530')
        } : null;
        data.Sections.find(obj => obj.SectionKey === 'S2.1').
          QuestionGroup.find(obj => obj.GroupKey === 'G6').
          Questions.find(obj => obj.QuestionKey === 'House_Shelters_Question').Answers = AnswerObject != null ? [AnswerObject] : null;

        break;
      case 'House_Annex_Less_50_Question':
        if (isNaN(selectedText)){
          this.error3 = true;
        }else if(selectedText === null || selectedText === '')
        {
          this.error3 = true;
        }
        else{
          this.error3 = false;
        }
        selectedQuestion = this.questions.find(obj => obj.QuestionKey === 'House_Annex_Less_50_Question');
        AnswerObject = !!selectedText || +(selectedText) === 0 ? {
          ChoiceId: selectedQuestion.QuestionId, Answerkey: selectedQuestion.QuestionKey, AnswerText: selectedText,
          AnsweredDateTime: formatDate(today, 'dd-MM-yyyy hh:mm:ss', 'en-US', '+0530')
        } : null;

        data.Sections.find(obj => obj.SectionKey === 'S2.1').
          QuestionGroup.find(obj => obj.GroupKey === 'G6').
          Questions.find(obj => obj.QuestionKey === 'House_Annex_Less_50_Question').Answers = AnswerObject != null ? [AnswerObject] : null;
        break;
    }
    sessionStorage.setItem('jsonData', JSON.stringify(data));
    return selectedText;
  }

  helpDialog(value: string) {
    value = this.translate.instant(value);
    this.notification.openDialog(value);
  }
  //#endregion
}
